import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store/store';

export interface QbankProgressSnapshot {
  answeredCount: number;
  submittedCount: number;
  totalCount: number;
  newCount: number;
  dueCount: number;
}

interface QbankProgressState {
  bySessionId: Record<string, QbankProgressSnapshot>;
}

const initialState: QbankProgressState = {
  bySessionId: {},
};

const qbankProgressSlice = createSlice({
  name: 'qbankProgress',
  initialState,
  reducers: {
    qbankProgressReceived: (
      state,
      action: PayloadAction<{
        studySessionId: string;
        progress: QbankProgressSnapshot;
      }>
    ) => {
      state.bySessionId[action.payload.studySessionId] =
        action.payload.progress;
    },
    qbankProgressCleared: (state) => {
      state.bySessionId = {};
    },
  },
});

export const selectQbankProgressForSession = createSelector(
  [
    (state: RootState) => state.qbankProgress.bySessionId,
    (_state: RootState, studySessionId?: string | null) => studySessionId,
  ],
  (bySessionId, studySessionId) =>
    studySessionId ? (bySessionId[studySessionId] ?? null) : null
);

export const { qbankProgressReceived, qbankProgressCleared } =
  qbankProgressSlice.actions;

export default qbankProgressSlice.reducer;
